module.exports = __webpack_public_path__ + "fonts/SegoeUI.31f5f7d.woff2";